import { fade, makeStyles, Theme } from '@material-ui/core';
import { ColorProperty } from 'csstype';

export const useStyles = makeStyles(({ custom, palette, shape }: Theme) => ({
  formGroup: {
    backgroundColor: palette.common.white,
    padding: '2px 12px',
    borderRadius: shape.borderRadius,
    border: `4px solid transparent`,
    '&.error': {
      border: `4px solid ${custom.status.danger.contrastText}`,
    },
  },
  checkboxRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:not(:last-child)': {
      borderBottom: `1px solid ${fade(custom.grey[4] as ColorProperty, 0.25)}`,
    },
    padding: '5px 0',
  },
  checkbox: {
    color: custom.grey[1],
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    color: custom.grey[3],
    fontSize: 13,
    cursor: 'pointer',
  },
  helpIcon: {
    fontSize: 18,
    color: custom.grey[1],
    marginRight: 10,
    marginLeft: 10,
  },
  label: {
    marginLeft: 15,
    fontSize: 14,
  },
}));
